import GridLayout, { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

const ResponsiveGridLayout = WidthProvider(Responsive);

const CustomiseLayout = (props) => {
  const responsiveProps = {
    className: "responsive-grid",
    breakpoints: { lg: 1200, md: 960, sm: 720, xs: 480, xxs: 0 },
    layouts: {},
    ...props,
    autoSize: true
  };

  return (
    <ResponsiveGridLayout {...responsiveProps}>
      {props.children}
    </ResponsiveGridLayout>
  );
};

export const CustomGridLayout = (props) => {
  return (
    <GridLayout {...props}>
      {props.children}
    </GridLayout>
  );
}

export default CustomiseLayout;
